<template>
  <div
    class="flowchart-container"
    @mousemove="handleMove"
    @mouseup="handleUp"
    @mousedown="handleDown"
    @drop="handleDrop"
    @dragover="allowDrop"
    @mouseleave="handleUp"
  >
    <div class="cameraContainer" :class="{ under: !pickedControllers['camera'] }">
      <div class="videoHeader">
        <img src="@/assets/icon/notice_close.png" @click="triggerController('camera')" />
      </div>
      <div class="videoWrapper" :style="{ transform: `rotate(${rotateDeg}deg)` }">
        <video
          class="mainframe"
          v-show="!isWifiCameraOn"
          ref="video"
          id="video"
          autoplay
          poster="@/assets/icon/camera_no_black.png"
        ></video>
         <canvas
            class="mainframe"
            v-show="isWifiCameraOn"
            height="320" width="480"
            ref="wifiVideo"
          />
      </div>
      <div class="videoButtonArea">
        <button @click="viedoRotate(-90)">
          <img src="@/assets/icon/img_turn_left.png" />
        </button>
        <button @click="viedoRotate(90)">
          <img src="@/assets/icon/img_turn_right.png" />
        </button>
      </div>
    </div>
    <div class="remote-controller">
      <ul class="icon-wrapper list-unstyled">
        <li @click="triggerController('manager')">
          <img
            :draggable="false"
            :src="
              require(`@/assets/icon/remote-controller/${
                pickedControllers['manager']
                  ? 'rc_robot_manager_pressed@2x'
                  : 'rc_robot_manager_normal@2x'
              }.png`)
            "
          />
        </li>
        <li @click="triggerController('show_value')">
          <img
            :draggable="false"
            :src="
              require(`@/assets/icon/remote-controller/${
                pickedControllers['show_value']
                  ? 'rc_show_value_pressed@2x'
                  : 'rc_show_value_normal@2x'
              }.png`)
            "
          />
        </li>

        <li @click="triggerController('camera')">
          <img
            :draggable="false"
            :src="
              require(`@/assets/icon/remote-controller/${
                pickedControllers['camera'] ? 'rc_camera_pressed@2x' : 'rc_camera_normal@2x'
              }.png`)
            "
          />
        </li>

        <li @click="triggerController('play')">
          <img
            :draggable="false"
            :src="
              require(`@/assets/icon/remote-controller/${
                pickedControllers['play'] ? 'rc_play_pressed@2x' : 'rc_play_normal@2x'
              }.png`)
            "
          />
        </li>

        <li @mousedown="triggerController('stop')">
          <img
            :draggable="false"
            :src="
              require(`@/assets/icon/remote-controller/${
                pickedControllers['stop'] ? 'rc_stop_pressed@2x' : 'rc_stop_normal@2x'
              }.png`)
            "
          />
        </li>
      </ul>
    </div>
    <svg
      ref="svg"
      width="100%"
      @click="clickCanvas"
      :height="`${height}px`"
      style="background-color:white"
      :style="linkLayerStyle"
    >
      <!-- <defs>
        <marker
          id="marker"
          refX="12"
          refY="6"
          markerWidth="12"
          markerHeight="12"
          orient="auto"
          stroke="#000000"
          stroke-width="2"
          fill="#ffffff#"
        >
          <circle cx="6" cy="6" r="5" />
        </marker>
      </defs>-->
      <flowchart-link
        v-bind.sync="link"
        v-for="(link, index) in lines"
        :key="`link${index}`"
        :centerX="scene.centerX"
        :centerY="scene.centerY"
        :links="scene.links"
        :nodes="scene.nodes"
        :scale="scene.scale"
        :giveFromNodetoLink="giveFromNodetoLink"
        @handleLinkCurve="handleLinkCurve"
        @deleteLink="linkDelete(link.id)"
      />
    </svg>

    <div
      class="node-layer"
      style="position:absolute;height:100%;width:100%;top:0;left:0;pointer-events: none;"
      :style="nodeLayerStyle"
    >
      <flowchart-node
        v-for="(value, key) in scene.nodes"
        v-bind.sync="value"
        :key="key"
        :options="nodeOptions"
        style="pointer-events: all;"
        @linkingStart="linkingStart(key, ...arguments)"
        @linkingStop="linkingStop(key, ...arguments)"
        @nodeSelected="nodeSelected(key, value, $event)"
        @changeInputCount="changeInputCount(key, ...arguments)"
        @nodeDbClick="nodeDbClick"
        @calcLines="calcLines"
        @changeOperator="changeOperator"
        @closeDropDown="closeDropDown"
        @copyNode="copyNode"
        @deleteNode="nodeDelete"
        :openValZone="pickedControllers.show_value"
        :dropDownTicktok="dropDownTicktok"
        :selectedNode="selectedNode"
      ></flowchart-node>
    </div>
  </div>
</template>

<script>
import { getMousePosition } from '@/assets/utilty/position';
import _ from 'lodash';
import FlowchartLink from '@/components/FlowchartLink.vue';
import FlowchartNode from '@/components/FlowchartNode.vue';
import mousetrap from 'mousetrap';

import { mapState } from 'vuex';

export default {
  name: 'VueFlowchart',
  props: {
    scene: {
      type: Object,
      default() {
        return {
          centerX: 1024,
          scale: 1,
          centerY: 140,
          transformX: 0,
          transformY: 0,
          nodes: {},
          links: [],
        };
      },
    },
    height: {
      type: Number,
      default: 400,
    },
    clearAll: {
      type: Boolean,
    },
    ticktokBle: {
      type: Number,
    },
    ticktokControllerManager: {
      type: Number,
    },
    ticktokControllerPlay: {
      type: Number,
    },
    selectedNode: {
      type: Array,
    },
  },
  data() {
    return {
      lines: [],
      action: {
        linking: false,
        dragging: false,
        scrolling: false,
        selected: 0,
      },
      mouse: {
        x: 0,
        y: 0,
        lastX: 0,
        lastY: 0,
      },
      draggingLink: null,
      rootDivOffset: {
        top: 0,
        left: 0,
      },
      // 給link接線時用的 因為沒有link id 所以只能直接給
      giveFromNodetoLink: {},
      pickedControllers: {
        manager: false,
        variable_manager: false,
        show_value: true,
        camera: false,
        play: false,
        stop: false,
      },
      dropDownTicktok: 0,
      rotateDeg: 0,
    };
  },
  components: {
    FlowchartLink,
    FlowchartNode,
  },
  computed: {
    ...mapState([
      'isWifiCameraOn',
    ]),
    nodeOptions() {
      return {
        centerY: this.scene.centerY,
        centerX: this.scene.centerX,
        scale: this.scene.scale,
        offsetTop: this.rootDivOffset.top,
        offsetLeft: this.rootDivOffset.left,
        selected: this.action.selected,
      };
    },

    linkLayerStyle() {
      return {
        transform: `translate(${this.scene.transformX}px,${this.scene.transformY}px) scale(${this.scene.scale})`,
        transformOrigin: '0 0',
        transition: 'transform 0.2s ease-in',
        overflow: 'visible!important',
      };
    },
    nodeLayerStyle() {
      return {
        transform: `translate(${this.scene.transformX}px,${this.scene.transformY}px) scale(${this.scene.scale})`,
        transformOrigin: '0 0',
        transition: 'transform 0.2s ease-in',
      };
    },
    // lines() {
    //   console.log("computed lines");
    //   const lines = this.scene.links.map(link => {
    //     const fromNode = this.findNodeWithID(link.from);
    //     const toNode = this.findNodeWithID(link.to);

    //     //這邊用不到 x 跟y了

    //     let x, y, cy, cx, ex, ey;
    //     x = this.scene.centerX + fromNode.x;
    //     y = this.scene.centerY + fromNode.y;
    //     [cx, cy] = this.getPortPosition("left", x, y, link);
    //     x = this.scene.centerX + toNode.x;
    //     y = this.scene.centerY + toNode.y;
    //     [ex, ey] = this.getPortPosition("right", x, y, link);
    //     console.log("去處", [ex, ey]);
    //     return {
    //       start: [cx, cy],
    //       end: [ex, ey],
    //       id: link.id
    //     };
    //   });
    //   if (this.draggingLink) {
    //     console.log("draging");
    //     let x, y, cy, cx;
    //     const fromNode = this.findNodeWithID(this.draggingLink.from);
    //     console.log("fromNode", fromNode);
    //     x = this.scene.centerX + fromNode.x;
    //     y = this.scene.centerY + fromNode.y;
    //     [cx, cy] = this.getPortPosition("left", x, y, this.draggingLink);
    //     // push temp dragging link, mouse cursor postion = link end postion
    //     lines.push({
    //       start: [cx, cy],
    //       end: [this.draggingLink.mx, this.draggingLink.my]
    //     });
    //   }
    //   return lines;
    // }
  },
  mounted() {
    this.rootDivOffset.top = this.$el ? this.$el.offsetTop : 0;
    this.rootDivOffset.left = this.$el ? this.$el.offsetLeft : 0;

    mousetrap.bind('del', () => {
      console.log('nodeOptions.selected delete ', this.nodeOptions.selected);
      this.nodeDelete(this.nodeOptions.selected);
    });
  },
  watch: {
    clearAll(val, oldVal) {
      if (val === true) {
        const path = [...this.$el.getElementsByTagName('path')];
        console.log('this.$refs', path);
        path.forEach((e) => {
          e.remove();
        });
        console.log('remove', val, oldVal);
        this.$emit('resetClearAll');
      }
    },

    ticktokControllerManager() {
      this.resetController('manager');
    },
    ticktokControllerPlay() {
      this.resetController('play');
    },
  },
  methods: {
    copyNode(id) {
      this.$emit('copyNode', this.scene.nodes[id]);
    },
    viedoRotate(degree) {
      this.rotateDeg = (this.rotateDeg + degree) % 360;
    },
    handleLinkCurve(id) {
      console.log('handleLinkCurve');
      const vm = this;
      function a(e) {
        console.log('move');
        const [x, y] = getMousePosition(
          vm.$el,
          e,
          vm.scene.scale,
          vm.scene.transformX,
          vm.scene.transformY,
        );
        console.log(x, y);
        const targetLink = vm.scene.links.find((el) => el.id === id);
        targetLink.curve = [x, y];
        console.log('targetLink', targetLink);
        vm.calcLines();
      }
      function b() {
        console.log('bbbbb');
        document.removeEventListener('mousemove', a);
        document.removeEventListener('mouseup', b);
      }
      document.addEventListener('mousemove', a);
      document.addEventListener('mouseup', b);
    },

    clickCanvas() {
      // console.log('clickCanvas');
      this.dropDownTicktok = -1;
      this.$emit('nodeUnselected');
    },
    closeDropDown(id) {
      console.log('closeDropDown');
      this.dropDownTicktok = id;
    },
    calcLines() {
      const lines = this.scene.links.map((link) => {
        const fromNode = this.findNodeWithID(link.from);
        const toNode = this.findNodeWithID(link.to);

        // 這邊用不到 x 跟y了

        let x;
        let y;
        x = this.scene.centerX + fromNode.x;
        y = this.scene.centerY + fromNode.y;
        const [cx, cy] = this.getPortPosition('left', x, y, link);
        x = this.scene.centerX + toNode.x;
        y = this.scene.centerY + toNode.y;
        const [ex, ey] = this.getPortPosition('right', x, y, link);
        return {
          start: [cx, cy],
          end: [ex, ey],
          id: link.id,
        };
      });
      if (this.draggingLink) {
        const fromNode = this.findNodeWithID(this.draggingLink.from);
        this.giveFromNodetoLink = fromNode;
        const x = this.scene.centerX + fromNode.x;
        const y = this.scene.centerY + fromNode.y;
        const [cx, cy] = this.getPortPosition('left', x, y, this.draggingLink);
        // push temp dragging link, mouse cursor postion = link end postion
        lines.push({
          start: [cx, cy],
          end: [this.draggingLink.mx, this.draggingLink.my],
        });
      }
      this.lines = lines;
    },

    findNodeWithID(key) {
      return this.scene.nodes[key];

      // return this.scene.nodes.find(item => {
      //   return id === item.id;
      // });
    },
    // input output點的位置
    // eslint-disable-next-line consistent-return
    getPortPosition(type, x, y, link) {
      // 左右指線的左右
      if (type === 'right') {
        // 如果 index 是自己的
        // count也是自己的就好了
        // link記

        const toNode = this.findNodeWithID(link.to);
        // 3.5 = portRadius/2
        // blockWidth不包含綠色部分
        // 80->node的高度
        // compare這個要砍掉 示範用
        // y +(toNode.blockHeight * (link.portIndex + 1)) / (link.portCount + 1)

        return [
          toNode.portStyle.input[link.portIndex][0],
          toNode.portStyle.input[link.portIndex][1],
        ];
      }
      if (type === 'left') {
        // console.log("left", link);
        const fromNode = this.findNodeWithID(link.from);
        let fromIndex;
        if (!this.draggingLink) {
          fromIndex = link.portOutIndex;
          // eslint-disable-next-line no-prototype-builtins
        } else if (this.draggingLink.from === link.from && link.hasOwnProperty('fromIndex')) {
          fromIndex = this.draggingLink.fromIndex;
        } else {
          fromIndex = link.portOutIndex;
        }

        return [fromNode.portStyle.output[fromIndex][0], fromNode.portStyle.output[fromIndex][1]];
      }
    },
    linkingStart(key, index) {
      this.action.linking = true;
      this.draggingLink = {
        from: key,
        fromIndex: index,
        mx: 0,
        my: 0,
      };
    },
    linkingStop(key, index, portCount) {
      // this.portIndex = index;
      // this.portCount = portCount;
      // add new Link
      if (this.draggingLink && this.draggingLink.from !== key) {
        // check link existence
        const existed = this.scene.links.find(
          (link) => link.from === this.draggingLink.from
            && link.to === key
            && link.portIndex === this.draggingLink.portIndex,
        );
        if (!existed) {
          // check input occupied if yes delete one
          this.checkInputOccupied(key, index);
          const maxID = Math.max(0, ...this.scene.links.map((link) => link.id));
          console.log('add');
          const newLink = {
            id: maxID + 1,
            from: this.draggingLink.from,
            to: key,
            portIndex: index,
            portCount,
            portOutIndex: this.draggingLink.fromIndex,
            curve: [],
          };
          this.scene.links.push(newLink);

          this.$emit('linkAdded', newLink);
        }
      }
      this.draggingLink = null;
    },
    linkDelete(id) {
      console.log('linkDelete');
      const deletedLink = this.scene.links.find((item) => item.id === id);
      if (deletedLink) {
        this.scene.links = this.scene.links.filter((item) => item.id !== id);
        this.$emit('linkBreak', deletedLink);
      }
      this.calcLines();
    },
    changeInputCount(key, val, oldVal) {
      console.log(key, val, oldVal);
      this.linkDeleteByInputChange(key, val, oldVal);
    },
    linkDeleteByInputChange(key, val) {
      // 本來有 1 2 3 4
      // 後來剩下 1 2
      // 砍掉2條線
      // key is from node
      // eslint-disable-next-line max-len
      this.scene.links = this.scene.links.filter(
        (item) => !(item.to === key && item.portIndex >= val),
      );

      this.scene.links.forEach((e) => {
        if (e.to === key) {
          e.portCount = val;
        }
      });
    },
    checkInputOccupied(key, index) {
      this.scene.links = this.scene.links.filter((e) => !(e.to === key && e.portIndex === index));
      this.calcLines();
    },
    nodeSelected(key, value, e) {
      this.action.dragging = key;
      this.action.selected = key;
      this.$emit('nodeClick', key, value);
      this.mouse.lastX = e.pageX || e.clientX + document.documentElement.scrollLeft;
      this.mouse.lastY = e.pageY || e.clientY + document.documentElement.scrollTop;
    },
    handleMove(e) {
      if (this.action.linking) {
        console.log('linking');
        [this.mouse.x, this.mouse.y] = getMousePosition(
          this.$el,
          e,
          this.scene.scale,
          this.scene.transformX,
          this.scene.transformY,
        );
        [this.draggingLink.mx, this.draggingLink.my] = [this.mouse.x, this.mouse.y];
        this.calcLines();
      }
      if (this.action.dragging) {
        console.log('dragging');
        this.mouse.x = e.pageX || e.clientX + document.documentElement.scrollLeft;
        this.mouse.y = e.pageY || e.clientY + document.documentElement.scrollTop;
        const diffX = (this.mouse.x - this.mouse.lastX) * 1;
        const diffY = (this.mouse.y - this.mouse.lastY) * 1;

        this.mouse.lastX = this.mouse.x;
        this.mouse.lastY = this.mouse.y;
        this.moveSelectedNode(diffX, diffY);
        this.moveLinkCurve(diffX, diffY);
      }
      if (this.action.scrolling) {
        // console.log("scrolling");
        [this.mouse.x, this.mouse.y] = getMousePosition(
          this.$el,
          e,
          this.scene.scale,
          this.scene.transformX,
          this.scene.transformY,
        );
        const diffX = this.mouse.x - this.mouse.lastX;
        const diffY = this.mouse.y - this.mouse.lastY;

        this.mouse.lastX = this.mouse.x;
        this.mouse.lastY = this.mouse.y;

        this.scene.centerX += diffX;
        this.scene.centerY += diffY;
        this.moveLinkCurve(diffX, diffY);

        // this.hasDragged = true
      }
    },
    handleUp(e) {
      const target = e.target || e.srcElement;
      if (this.$el.contains(target)) {
        if (typeof target.className !== 'string' || target.className.indexOf('node-input') < 0) {
          this.draggingLink = null;
        }
        if (typeof target.className === 'string' && target.className.indexOf('node-delete') > -1) {
          this.nodeDelete(this.action.dragging);
        }
      }
      this.action.linking = false;

      this.action.dragging = null;

      this.action.scrolling = false;
      this.calcLines();
    },
    handleDown(e) {
      const target = e.target || e.srcElement;
      // console.log(this.$el, e.which);
      // console.log("target", target);

      if ((target === this.$el || target.matches('svg, svg *')) && e.which === 1) {
        // 點在畫布上
        // console.log("點在畫布上");
        this.action.scrolling = true;
        [this.mouse.lastX, this.mouse.lastY] = getMousePosition(
          this.$el,
          e,
          this.scene.scale,
          this.scene.transformX,
          this.scene.transformY,
        );
        // console.log("mousedown", this.mouse.lastX, this.mouse.lastY);
        this.action.selected = null; // deselectAll
      }
      this.$emit('canvasClick', e);
    },
    handleDrop(e) {
      this.$emit(
        'addNodeFromDrop',
        e,
        ...getMousePosition(
          this.$el,
          e,
          this.scene.scale,
          this.scene.transformX,
          this.scene.transformY,
        ),
      );
    },
    allowDrop(event) {
      event.preventDefault();
    },
    moveLinkCurve(dx, dy) {
      console.log('moveLinkCurve');
      Object.keys(this.scene.links).forEach((key) => {
        if (this.scene.links[key].curve.length > 0) {
          this.scene.links[key].curve[0] += dx;
          this.scene.links[key].curve[1] += dy;
        }
      });
    },
    moveSelectedNode(dx, dy) {
      let targetkey = 0;
      Object.keys(this.scene.nodes).forEach((key) => {
        if (key === this.action.dragging) {
          targetkey = key;
        }
      });

      // let index = this.scene.nodes.findIndex(item => {
      //   return item.id === this.action.dragging;
      // });
      const left = this.scene.nodes[targetkey].x + dx / this.scene.scale;
      const top = this.scene.nodes[targetkey].y + dy / this.scene.scale;
      this.$set(
        this.scene.nodes,
        targetkey,
        Object.assign(this.scene.nodes[targetkey], {
          x: left,
          y: top,
        }),
      );

      this.calcLines();
    },
    nodeDelete(id) {
      const delnodeTemp = this.scene.nodes[id];
      this.$emit('nodeDelete', delnodeTemp);
      delete this.scene.nodes[id];
      this.scene.links = this.scene.links.filter(
        (link) => link.from !== id.toString() && link.to !== id.toString(),
      );
      this.calcLines();
    },
    nodeDbClick(id) {
      this.$emit('nodeDbClick', id);
    },
    changeOperator(id) {
      this.$emit('changeOperator', id);
    },
    doWheel: _.throttle(function (e) {
      const { deltaY } = e;
      let times = Math.abs(deltaY / 100);

      let ratio = 1;

      if (deltaY < 0) {
        // Zoom in
        while (times) {
          ratio *= 1.05;
          times -= 1;
        }
      } else {
        // Zoom out
        while (times) {
          ratio /= 1.05;
          times -= 1;
        }
      }

      const delm = document.documentElement;
      const oz = this.scene.scale;
      const nz = this.scene.scale * ratio;
      /// scroll offset
      const sx = delm.scrollLeft;
      const sy = delm.scrollTop;
      /// offset of container
      const ox = 266;
      const oy = 180;
      /// mouse cords
      const mx = e.clientX - ox + sx;
      const my = e.clientY - oy + sy;
      /// calculate click at current zoom
      const ix = (mx - this.scene.transformX) / oz;
      const iy = (my - this.scene.transformY) / oz;
      /// calculate click at new zoom
      const nx = ix * nz;
      const ny = iy * nz;
      /// move to the difference
      /// make sure we take mouse pointer offset into account!
      const cx = ix + (mx - ix) - nx;
      const cy = iy + (my - iy) - ny;
      // update current

      if (this.scene.scale !== nz && nz <= 2 && nz >= 1) {
        this.scene.scale = nz;
        this.scene.transformX = cx;
        this.scene.transformY = cy;
      }
    }, 200),

    triggerController(val) {
      // if (this.pickedController === val) {
      //   this.resetController();
      // }
      // play執行中 不往上傳
      if (val === 'play' && this.pickedControllers[val] === true) {
        return;
      }

      if (val === 'stop') {
        console.log('stop');
        document.addEventListener('mouseup', this.resetController);
      }

      this.pickedControllers[val] = !this.pickedControllers[val];

      this.$emit('triggerController', val);
    },
    resetController(val) {
      if (val instanceof Event) {
        // stop mouseup 觸發
        // eslint-disable-next-line no-param-reassign
        val = 'stop';
      }

      this.pickedControllers[val] = false;

      if (val === 'stop') {
        console.log('有remove');
        this.pickedControllers.play = false;
        document.removeEventListener('mouseup', this.resetController);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.flowchart-container {
  margin: 0;
  background: white;
  position: relative;
  overflow: hidden;
  cursor: grab;
  height: 100%;

  .cameraContainer {
    position: absolute;
    left: 16px;
    top: 95px;
    width: 400px;
    height: 425px;
    background-color: #282828;
    z-index: 999;
    border-radius: 10px;
    cursor: auto;
    &.under {
      z-index: -1;
    }
    .videoHeader {
      display: flex;
      justify-content: flex-end;
      height: 60px;
      img {
        height: 16px;
        /* padding: 10px; */
        margin: 10px;
        cursor: pointer;
      }
    }
    .mainframe {
      width: 100%;
    }
    .videoButtonArea {
      display: flex;
      position: absolute;
      bottom: 0px;
      justify-content: center;
      align-items: center;
      width: 100%;
      background-color: #3c3d3e;
      border-radius: 0px 0px 10px 10px;
      height: 80px;
      button {
        width: 145px;
        height: 35px;
        border-radius: 18px;
        border: solid 1px #9b9c9e;
        background-color: transparent;
        margin: 0px 5px;
        &:hover {
          background-color: #ffffff;
        }
        img {
          height: 23px;
        }
      }
    }
  }
  .remote-controller {
    position: absolute;
    left: 16px;
    top: 16px;
    border-radius: 10px;
    background-color: #c6c8cb;
    z-index: 999;
    cursor: auto;

    .icon-wrapper {
      padding: 10px;
      display: flex;
      margin-bottom: 0;

      li {
        &:first-of-type {
          margin-left: 0;
        }
        margin-left: 8px;
      }
      img {
        cursor: pointer;
        height: 45px;
        width: 45px;
      }
    }
  }
}
</style>
